import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears } from "./../Utils";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";
import "../../css/Tabss.css"

// Importing assets
import ProfileImage from "../../assets/images/all/Instituteimage.png";
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import octiconImage from "../../assets/images/icons/octicon_upload-16.svg"

import SearchIcon from "../../assets/images/all/search.svg";

import CommanInstitute from '../../components/CommanInstitute';
import TeacherImage from '../../assets/images/icons/teacehr_+.svg'
import downArrowImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 4.svg'
import UpImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 3.svg'


const CourseStructure = (props) => {

    const navigate = useNavigate();



    /// Stream end
    // console.log("streamDetailsstreamDetails", managers)
    return (
        <div className="bg_dashboard">

            <div className="container">
                <div className="row">

                    <CommanInstitute />


                    <div class="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
                    <div className="row mt-5">
                    <div className="col-md-9 ps-0">
                        <div className="search-box dashboard_search">
                            <input type="text"
                                className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input"
                                placeholder="Search"/>
                            <button type="submit" className="btn btn-main spl_burron  border-0"><img
                                    src={SearchIcon} alt="" /></button>
                        </div>
                    </div>
                    <div className="col-md-2 text-xl-center  mt-3">
                        <img src={NotificationIcon} alt="" />
                    </div>
                    <div className="col-md-1">
                        <div className="dashboard_profile ms-auto">
                            <img src={ProfileImage} alt=""/>
                        </div>
                    </div>
                </div>



                        <div class="row px-0 py-3">
                            <div class="col-sm-12">
                                <h2 class="learm-tilte">Course Structure</h2>
                                <p>The following descriptions will be publicly visible on your Course Landing Page and will have a direct impact on your course performance. These descriptions will help learners decide if your course is right for them.</p>
                            </div>
                        </div>

                        <div class="row p-0 mt-1">
                            <div class="dashboard_card p-0">

                                <div class="row px-0 px-sm-3">
                                    <div class="col-sm-12">
                                        <div class="dashboard_card p-4">

                                            <label for="courseDescription" class="profile_text_2 mb-1">Learning Outcomes</label>
                                            <p class="mb-2">You must enter at least 4 learning objectives or outcomes that
                                                learners can expect to achieve after
                                                completing your course.</p>

                                            <div class="mt-2">
                                                <label for="courseDescription" class="profile_text_2 mb-2 font-16">Answer
                                                    1</label>
                                                <div class="position-relative">
                                                    <input type="text" class="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle" placeholder="Choose catogry" maxlength="60" />
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <label for="courseDescription" class="profile_text_2 mb-2 font-16">Answer
                                                    1</label>
                                                <div class="position-relative">
                                                    <input type="text" class="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle" placeholder="Choose catogry" maxlength="60" />
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <label for="courseDescription" class="profile_text_2 mb-2 font-16">Answer
                                                    1</label>
                                                <div class="position-relative">
                                                    <input type="text" class="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle" placeholder="Choose catogry" maxlength="60" />
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <label for="courseDescription" class="profile_text_2 mb-2 font-16">Answer
                                                    1</label>
                                                <div class="position-relative">
                                                    <input type="text" class="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle" placeholder="Choose catogry" maxlength="60" />
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <label for="courseDescription" class="profile_text_2 mb-2 font-16">Answer
                                                    1</label>
                                                <div class="position-relative">
                                                    <input type="text" class="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle" placeholder="Choose catogry" maxlength="60" />
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <button type="button" class="me-2"><img
                                                    src={TeacherImage} alt="" /></button>
                                                <span>Add
                                                    more outcomes</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="row p-0 mt-3">
                            <div class="dashboard_card p-0">

                                <div class="row px-0 px-sm-3">
                                    <div class="col-sm-12">
                                        <div class="dashboard_card p-4">

                                            <p class="mb-2">Any time a student uses this link, we will credit you with the sale.
                                            </p>

                                            <div class="position-relative">
                                                <input type="text" class="common-input common-input--md dash_borad_input_1"
                                                    id="courseTitle"
                                                    placeholder="e.g. The Complete AP &amp; College Physics Cou" maxlength="60" />

                                            </div>

                                            <div class="mt-3">
                                                <button type="button" class="me-2"><img
                                                    src={TeacherImage} alt="" /></button>
                                                <span>Add
                                                    more outcomes</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-5 mt-3">
                            <div class="col-sm-12 d-flex justify-content-between">
                                <span class="learm-tilte2 font-16" onClick={() => navigate("/CourseStructure")}><img
                                    src={downArrowImage} alt="" /> Previous</span>
                                <span class="learm-tilte2 font-16" onClick={() => navigate("/CourseCircullam")}>Next <img
                                    src={UpImage} alt="" /></span>
                            </div>
                        </div>



                    </div>
                </div>

            </div>






            {/* Footer */}
            <Footer />
        </div>
    );
};

export default CourseStructure;






